module.exports = __webpack_public_path__ + "static/media/48845dff.jpg";